import { Box, styled } from "@mui/material";
import { deepPurple } from "@mui/material/colors";

export const AverageHighlightBox = styled(Box)({
  textAlign: "center",
  paddingLeft: 16,
  paddingRight: 16,
  borderRadius: 6,
  backgroundColor: deepPurple[50],
  border: `1px solid ${deepPurple[100]}`,
});
